// Classes.
import { BookItem } from './bookItem';
import { Interpretation } from './interpretation';
import { Title } from '@angular/platform-browser';


export class Interpretations {

  public approved: string;
  public effective: string;
  public dismiss: boolean;
  public related: string;
  public title: string;
  public content: string;
  public articles: Array<{ title: string, id: string }>
  public documents: Array<{ title: string, link: string }>
  constructor(rawArticle: any) {
    this.approved = rawArticle.approved;
    this.effective = rawArticle.effective;
    this.dismiss = rawArticle.dismiss;
    this.related = rawArticle.related;
    this.title = rawArticle.title;
    this.content = rawArticle.content;
    this.articles = rawArticle.articles;
    this.documents = rawArticle.documents;
  }


}
